export default "__VITE_ASSET__CQgsbAcJ__"